(function () {
  if (window.__AG_PB_BUTTON_INIT__) return;
  window.__AG_PB_BUTTON_INIT__ = true;

  var SELECTOR = '[data-ag-pb-scroll-to-product-details]';

  function readPxVar(name, fallback) {
    var raw = getComputedStyle(document.documentElement).getPropertyValue(name);
    var n = parseFloat(raw);
    return Number.isFinite(n) ? n : fallback;
  }

  function headerOffset() {
    var header = readPxVar('--header-height', 0);
    var announcement = readPxVar('--announcement-bar-height', 0);
    /* Extra breathing room under sticky chrome (theme --anchor-offset default 20) */
    var extra = readPxVar('--anchor-offset', 24);
    return header + announcement + extra;
  }

  function isShown(el) {
    if (!el || !el.getClientRects) return false;
    return el.getClientRects().length > 0;
  }

  function resolveScrollTarget() {
    var roots = document.querySelectorAll('[data-ag-pb-product-plans]');
    var i;
    var root;
    var target;

    for (i = 0; i < roots.length; i++) {
      root = roots[i];
      if (!isShown(root)) continue;
      target = root.querySelector('[data-ag-pb-product-plans-scroll]') || root;
      if (isShown(target) || isShown(root)) return target;
    }

    return (
      document.querySelector('[data-ag-pb-product-plans-scroll]') ||
      document.querySelector('[data-ag-pb-product-plans]') ||
      document.getElementById('ag-pb-product-details') ||
      document.querySelector('[data-ag-pb-product-details]') ||
      document.getElementById('ag-pb-sale-offer') ||
      document.querySelector('[data-ag-pb-sale-offer]')
    );
  }

  function scrollToOfferTarget(event) {
    var link = event.target.closest(SELECTOR);
    if (!link) return;

    var target = resolveScrollTarget();
    if (!target) return;

    event.preventDefault();

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });

    if (typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (err) {
        target.focus();
      }
    }
  }

  document.addEventListener('click', scrollToOfferTarget);
})();
